import axios from 'axios';

const ERapidApiAxios = axios.create();
const ERapidAuthAxios = axios.create();

ERapidApiAxios.defaults.headers.common['Content-Type'] = 'application/json';
ERapidAuthAxios.defaults.headers.common['Content-Type'] = 'application/json';
//Allow the use of array parameter with key value
//ERapidApiAxios.defaults.headers.common['WWW-Authenticate'] = 'jasdfjklasdfjklsdfjklsdfjklsdfjklsdf';


export { ERapidApiAxios, ERapidAuthAxios };
